export const constants = {
  MFE_NAME: 'primaryMarkets',
  MFE_EXPOSED_PATH: './PrimaryMarketsApp',
  MC_OPPORTUNITY_DETAILS_EXPOSED_PATH: './OpportunityDetails',
};
